export const SCORING_TIMEOUT = 5 * 60 * 1000; // 5 min
export const LEADMARKET_IMPERSONATION_TIMEOUT = 60 * 1000; // 1 min
export const LEADMARKET_IMPERSONATION_INTERVAL = 10 * 1000; // 10 sec
export const LEADMARKET_IMPERSONATION_TIMEOUT_COUNT = 31;
